import type { StateHolder } from '@/util/dataState';

export enum SurgicalGuideOrderState {
    Ordered = 'ordered',
    Requested = 'requested',
    Cancelled = 'cancelled',
    Accepted = 'accepted',
    Rejected = 'rejected',
}

export type SurgicalGuideOrder = {
    id: number,
    caseId: number,
    planId: number,
    state: SurgicalGuideOrderState,
    scansLastDownloadedAt: string | null,
    modelsLastDownloadedAt: string | null,
};

export type SurgicalGuideOrdersState = {
    orders: SurgicalGuideOrder[]
}  & StateHolder;
